<div class="container py-3" [nbSpinner]="loading">
    <app-back-button class="mb-3" [route]="backRoute"></app-back-button>
    <nb-card>
        <nb-card-body class="py-4">
            <h1 class="h-tournament-title">
                {{ playerTrailData?.tournament?.nome_torneio }}
            </h1>
            <div class="row">
                <div class="col-lg-12">
                    <!-- No player selected message -->
                    <div class="no-player-selected mb-4" *ngIf="!selectedPlayerData && !loading">
                        <nb-card class="text-center">
                            <nb-card-body class="py-5">
                                <nb-icon
                                    icon="person-outline"
                                    class="text-muted mb-3"
                                    style="font-size: 4rem"
                                ></nb-icon>
                                <h5 class="text-muted mb-3">Nenhum participante selecionado</h5>
                                <p class="text-muted mb-4">
                                    Selecione um participante para visualizar seus jogos no torneio.
                                </p>
                                <button nbButton status="primary" size="medium" (click)="openPlayerSelectionDialog()">
                                    <nb-icon icon="person-add-outline" class="mr-2"></nb-icon>
                                    Selecionar Participante
                                </button>
                            </nb-card-body>
                        </nb-card>
                    </div>

                    <div class="selected-player-section mb-2" *ngIf="selectedPlayerData">
                        <nb-card class="player-header-card">
                            <nb-card-body class="p-4">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                        <div class="player-avatar-section">
                                            <img
                                                [src]="selectedPlayerData.avatar"
                                                [alt]="selectedPlayerData.nome_abreviado"
                                                class="selected-player-avatar"
                                            />
                                        </div>

                                        <div class="player-info-section ml-4">
                                            <h4 class="player-name mb-1">{{ selectedPlayerData.nome_abreviado }}</h4>
                                            <div class="player-details">
                                                <div class="player-age">{{ selectedPlayerData.idade }} anos</div>
                                                <div class="player-location">
                                                    {{ selectedPlayerData.nome_cidade }},
                                                    {{ selectedPlayerData.sigla_uf }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="player-actions">
                                        <button
                                            nbButton
                                            status="basic"
                                            size="small"
                                            (click)="openPlayerSelectionDialog()"
                                            class="change-player-btn"
                                        >
                                            <nb-icon icon="person-outline" class="mr-2"></nb-icon>
                                            Alterar jogador
                                        </button>
                                    </div>
                                </div>
                            </nb-card-body>
                        </nb-card>
                    </div>

                    <!-- Filters and content only show when player is selected -->
                    <div *ngIf="selectedPlayerData">
                        <div class="filters-section mb-2">
                            <nb-card class="filter-card">
                                <nb-card-body class="p-3">
                                    <div class="row align-items-center">
                                        <div class="col-lg-6">
                                            <label class="label mb-2">Filtrar por categoria:</label>
                                            <nb-select
                                                size="small"
                                                placeholder="Selecione uma categoria"
                                                fullWidth
                                                [(ngModel)]="selectedCategory"
                                                (selectedChange)="onCategoryChange($event)"
                                            >
                                                <nb-option value="">Todas as categorias</nb-option>
                                                <nb-option
                                                    *ngFor="let category of categories"
                                                    [value]="category.id_categoria"
                                                >
                                                    {{ category.descricao }}
                                                </nb-option>
                                            </nb-select>
                                        </div>
                                    </div>
                                </nb-card-body>
                            </nb-card>
                        </div>

                        <div class="player-trail-content" *ngIf="playerTrailData">
                            <div class="categories-section">
                                <div
                                    class="category-block mb-5"
                                    *ngFor="let category of playerTrailData.games; let i = index"
                                >
                                    <div class="category-header mb-4">
                                        <h5 class="text-primary mb-0">{{ category.category }}</h5>
                                        <hr class="mt-2" />
                                    </div>

                                    <!-- Group Games Section -->
                                    <div class="group-section" *ngIf="hasGroupGames(category)">
                                        <div class="section-header mb-3">
                                            <h6 class="text-secondary mb-0">Jogos de Grupo</h6>
                                            <hr class="mt-1" />
                                        </div>
                                        <div class="timeline-container">
                                            <div
                                                class="timeline-item"
                                                *ngFor="let dateGroup of groupGamesByDate[i]; let isLast = last"
                                                [class.timeline-item-last]="isLast"
                                            >
                                                <div class="timeline-date">
                                                    <div class="date-display">
                                                        {{ dateGroup.date | date : "dd/MM/yyyy" }}
                                                    </div>
                                                    <div class="timeline-line" *ngIf="!isLast"></div>
                                                </div>

                                                <div class="timeline-content">
                                                    <div class="game-card" *ngFor="let game of dateGroup.games">
                                                        <div class="game-header mb-3">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center"
                                                            >
                                                                <div class="game-badges">
                                                                    <nb-tag
                                                                        status="basic"
                                                                        size="small"
                                                                        class="mr-2"
                                                                        [text]="
                                                                            game.nr_rodada
                                                                                ? 'Rodada ' + game.nr_rodada
                                                                                : 'Grupo'
                                                                        "
                                                                        size="small"
                                                                    ></nb-tag>
                                                                    <nb-tag
                                                                        status="basic"
                                                                        size="small"
                                                                        text="Jogo {{ game.nr_jogo }}"
                                                                        size="small"
                                                                    ></nb-tag>
                                                                </div>
                                                                <div class="game-time" *ngIf="game.hr_jogo">
                                                                    <small class="text-muted">{{ game.hr_jogo }}</small>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="players-match">
                                                            <div
                                                                class="d-flex align-items-center justify-content-between"
                                                            >
                                                                <div class="player-side">
                                                                    <div
                                                                        class="player-info"
                                                                        *ngFor="let player of game.players[1]"
                                                                    >
                                                                        <div class="player-avatar-container">
                                                                            <img
                                                                                [src]="player.avatar"
                                                                                [alt]="player.nome_abreviado"
                                                                                class="player-avatar"
                                                                            />
                                                                        </div>
                                                                        <div class="player-details ml-3">
                                                                            <div class="player-name">
                                                                                {{ player.nome_abreviado }}
                                                                            </div>
                                                                            <div class="player-location text-muted">
                                                                                {{ player.nome_cidade }},
                                                                                {{ player.sigla_uf }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        *ngIf="game.players[1].length === 0"
                                                                        class="player-info text-muted"
                                                                    >
                                                                        A definir
                                                                    </div>
                                                                </div>

                                                                <div class="player-center">
                                                                    <div class="vs-divider">
                                                                        <div class="result-1">
                                                                            {{ game.resultado_1 }}
                                                                        </div>
                                                                        <div class="vs-circle">
                                                                            <span class="vs-text">VS</span>
                                                                        </div>
                                                                        <div class="result-2">
                                                                            {{ game.resultado_2 }}
                                                                        </div>
                                                                    </div>
                                                                    <button
                                                                        nbButton
                                                                        status="basic"
                                                                        size="tiny"
                                                                        *ngIf="game?.sub_games?.length"
                                                                        (click)="openGameDetails(game)"
                                                                    >
                                                                        <nb-icon icon="eye-outline"></nb-icon>
                                                                        Ver detalhes
                                                                    </button>
                                                                </div>

                                                                <div class="player-side">
                                                                    <div
                                                                        class="player-info d-flex align-items-center"
                                                                        *ngFor="let player of game.players[2]"
                                                                    >
                                                                        <div class="player-avatar-container">
                                                                            <img
                                                                                [src]="player.avatar"
                                                                                [alt]="player.nome_abreviado"
                                                                                class="player-avatar"
                                                                            />
                                                                        </div>
                                                                        <div class="player-details ml-3">
                                                                            <div class="player-name">
                                                                                {{ player.nome_abreviado }}
                                                                            </div>
                                                                            <div class="player-location text-muted">
                                                                                {{ player.nome_cidade }},
                                                                                {{ player.sigla_uf }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        *ngIf="game.players[2].length === 0"
                                                                        class="player-info text-muted"
                                                                    >
                                                                        A definir
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Bracket Games Section (Chaves) -->
                                    <div class="bracket-section" *ngIf="hasBracketGames(category)">
                                        <div class="section-header mb-3">
                                            <h6 class="text-secondary mb-0">Chaves</h6>
                                            <hr class="mt-1" />
                                        </div>
                                        <div class="timeline-container">
                                            <div
                                                class="timeline-item"
                                                *ngFor="let dateGroup of bracketGamesByDate[i]; let isLast = last"
                                                [class.timeline-item-last]="isLast"
                                            >
                                                <div class="timeline-date">
                                                    <div class="date-display">
                                                        {{ dateGroup.date | date : "dd/MM/yyyy" }}
                                                    </div>
                                                    <div class="timeline-line" *ngIf="!isLast"></div>
                                                </div>

                                                <div class="timeline-content">
                                                    <div class="game-card" *ngFor="let game of dateGroup.games">
                                                        <div class="game-header mb-3">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center"
                                                            >
                                                                <div class="game-badges">
                                                                    <nb-tag
                                                                        status="basic"
                                                                        size="small"
                                                                        class="mr-2"
                                                                        text="Rodada {{ game.nr_rodada }}"
                                                                        size="small"
                                                                    ></nb-tag>
                                                                    <nb-tag
                                                                        status="basic"
                                                                        size="small"
                                                                        text="Jogo {{ game.nr_jogo }}"
                                                                        size="small"
                                                                    ></nb-tag>
                                                                </div>
                                                                <div class="game-time" *ngIf="game.hr_jogo">
                                                                    <small class="text-muted">{{ game.hr_jogo }}</small>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="players-match">
                                                            <div
                                                                class="d-flex align-items-center justify-content-between"
                                                            >
                                                                <div class="player-side">
                                                                    <div
                                                                        class="player-info d-flex align-items-center"
                                                                        *ngFor="let player of game?.players[1]"
                                                                    >
                                                                        <div class="player-avatar-container">
                                                                            <img
                                                                                [src]="player.avatar"
                                                                                [alt]="player.nome_abreviado"
                                                                                class="player-avatar"
                                                                            />
                                                                        </div>
                                                                        <div class="player-details ml-3">
                                                                            <div class="player-name">
                                                                                {{ player.nome_abreviado }}
                                                                            </div>
                                                                            <div class="player-location text-muted">
                                                                                {{ player.nome_cidade }},
                                                                                {{ player.sigla_uf }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        *ngIf="game?.players[1]?.length === 0"
                                                                        class="player-info text-muted"
                                                                    >
                                                                        A definir
                                                                    </div>
                                                                </div>

                                                                <div class="player-center">
                                                                    <div class="vs-divider">
                                                                        <div class="result-1">
                                                                            {{ game.resultado_1 }}
                                                                        </div>
                                                                        <div class="vs-circle">
                                                                            <span class="vs-text">VS</span>
                                                                        </div>
                                                                        <div class="result-2">
                                                                            {{ game.resultado_2 }}
                                                                        </div>
                                                                    </div>
                                                                    <button
                                                                        nbButton
                                                                        status="basic"
                                                                        size="tiny"
                                                                        *ngIf="game?.sub_games?.length"
                                                                        (click)="openGameDetails(game)"
                                                                    >
                                                                        <nb-icon icon="eye-outline"></nb-icon>
                                                                        Ver detalhes
                                                                    </button>
                                                                </div>

                                                                <div class="player-side">
                                                                    <div
                                                                        class="player-info"
                                                                        *ngFor="let player of game.players[2]"
                                                                    >
                                                                        <div class="player-avatar-container">
                                                                            <img
                                                                                [src]="player.avatar"
                                                                                [alt]="player.nome_abreviado"
                                                                                class="player-avatar"
                                                                            />
                                                                        </div>
                                                                        <div class="player-details ml-3">
                                                                            <div class="player-name">
                                                                                {{ player.nome_abreviado }}
                                                                            </div>
                                                                            <div class="player-location text-muted">
                                                                                {{ player.nome_cidade }},
                                                                                {{ player.sigla_uf }}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        *ngIf="game?.players[2]?.length === 0"
                                                                        class="player-info text-muted"
                                                                    >
                                                                        A definir
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="no-data-message text-center py-5" *ngIf="!loading && !playerTrailData">
                            <nb-icon icon="search-outline" class="text-muted mb-3" style="font-size: 3rem"></nb-icon>
                            <h6 class="text-muted">Nenhum dado de jogos encontrado</h6>
                            <p class="text-muted">Verifique se há jogos programados para este jogador.</p>
                        </div>
                    </div>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</div>
